<template>
  <span class="inline-flex flex-col items-start gap-y-1 xl:flex-row xl:flex-nowrap xl:items-center xl:gap-x-2">
    <span
      class="inline-flex items-start gap-2 text-sm font-medium leading-5 text-right xl:text-left xl:whitespace-nowrap"
      :class="badge.text"
    >
      <span class="mt-1.5 h-2 w-2 shrink-0 rounded-full" :class="badge.dot" aria-hidden="true" />
      {{ badge.label }}
    </span>
    <template v-if="badge.detail">
      <span class="sr-only">{{ badge.separator ?? " · " }}</span>
      <span class="text-xs text-boba-grey-dark" :class="detailClass">{{ badge.detail }}</span>
    </template>
  </span>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { Listing, ListingBid } from "@/types";
import { describeBidStatus } from "@/util/bidStatus";

const props = withDefaults(
  defineProps<{
    listing: Listing;
    bid: ListingBid;
    /** Extra classes for the detail line (e.g. to hide it on small screens). */
    detailClass?: string;
  }>(),
  { detailClass: "" },
);

const badge = computed(() => describeBidStatus(props.listing, props.bid));
</script>
